var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightHandAbove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 1183,
    viewBox: "0 0 422 1183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.914 354.624L272.215 375.403C266.196 395.638 257.033 411.633 175.938 536.179L233.497 549.996L354.113 377.739C353.703 375.414 313.779 380.057 294.914 354.624Z",
    fill: "#FFCF54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.24 1182.04C293.24 1182.04 214.292 672.862 219.24 637.545C224.187 602.229 398.679 413.02 398.679 413.02C402.508 407.552 404.013 402.493 405.518 397.435C406.612 390.052 405.383 383.078 404.153 376.105L325.983 109.479C321.2 95.9427 309.443 83.6358 294.267 79.1217C271.708 73.5128 248.189 89.6432 244.905 111.792C243.4 116.851 244.63 123.824 245.449 128.473L295.322 356.948L272.623 377.728C278.232 355.169 262.101 331.65 239.952 328.365C224.776 323.851 209.325 331.369 198.933 340.391L35.1079 539.441C27.0399 548.054 21.7061 558.581 19.1066 571.022C16.5071 583.464 16.2319 595.496 17.8714 604.793L114.739 1182.04H293.24Z",
    fill: "#FFCF54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.338 391.669C248.459 389.179 257.888 375.713 255.398 361.592C252.908 347.471 239.442 338.042 225.321 340.532C211.2 343.022 201.771 356.488 204.261 370.609C206.751 384.73 220.217 394.159 234.338 391.669Z",
    fill: "#FFF2D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightHandAbove);
export default __webpack_public_path__ + "static/media/right-hand-above.28b3561fbc481709c41cbc0927b1b21d.svg";
export { ForwardRef as ReactComponent };